/** @format */

import {useForm, ValidationError} from '@formspree/react'
import React, {useContext} from 'react'

import Modal from '../components/tailwind/Modal'
import {AccountContext} from '../contexts/AccountContext'
import {CheckoutContext} from './CheckoutContext'
import {STEPS} from './constants'

export default function NeedMoreModal(props) {
  const {productId, prefix = '', noMobileScroll} = props
  const {currentStep, currentModal, closeModal} = useContext(CheckoutContext)
  const {profile} = useContext(AccountContext)
  const [state, handleSubmit] = useForm('xpooeyom')

  return (
    <Modal
      isOpen={
        currentModal === prefix + productId && currentStep === STEPS.SALES
      }
      onClose={closeModal}
      title="Contact Sales"
      noMobileScroll={noMobileScroll}
    >
      {state.succeeded ? (
        <div className={'w-full'}>
          <p>
            Thanks for reaching out! Our sales team will review your request and
            get back to you shortly.
          </p>
          <div className={'mt-6'}>
            <button
              className="buttonPrimary float-right"
              type="button"
              onClick={closeModal}
            >
              Close
            </button>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className={'w-full'} noValidate>
          <input type="hidden" name="_tags" value="sales_inquiry" />
          {!profile ? (
            <>
              <label>Name:</label>
              <input type="text" name="name" required />
              <ValidationError
                prefix="Name"
                field="name"
                errors={state.errors}
                className={'text-sm text-red-600'}
              />
              <label>Company:</label>
              <input type="text" name="company" />
              <ValidationError
                prefix="Company"
                field="company"
                errors={state.errors}
                className={'text-sm text-red-600'}
              />
            </>
          ) : null}
          <label>Company Email:</label>
          <input
            type="email"
            name="email"
            required
            defaultValue={profile ? profile.email : null}
          />
          <ValidationError
            prefix="Email"
            field="email"
            errors={state.errors}
            className={'text-sm text-red-600'}
          />
          <p className={'mb-2 mt-4'}>I'm interested in:</p>
          <label className={'mb-2 block'}>
            <input
              type="checkbox"
              name="more_submissions"
              className={'inline'}
            />{' '}
            More submissions per month
          </label>
          <label className={'mb-2 block'}>
            <input
              type="checkbox"
              name="more_projects_forms"
              className={'inline'}
            />{' '}
            More projects or forms
          </label>
          <label className={'mb-2 block'}>
            <input type="checkbox" name="autoverify" className={'inline'} />{' '}
            Auto-verification of linked emails
          </label>
          <label className={'mb-2 block'}>
            <input type="checkbox" name="sla" className={'inline'} /> A Service
            Level Agreement (SLA)
          </label>
          <label className={'mb-2 block'}>
            <input
              type="checkbox"
              name="full_service_onboarding"
              className={'inline'}
            />{' '}
            Full service onboarding / migration of existing forms
          </label>
          <label className={'mb-2 block'}>
            <input type="checkbox" name="support" className={'inline'} />{' '}
            Dedicated support or phone support
          </label>
          <label className={'mt-4'}>Please describe your needs:</label>
          <textarea name="other" required />
          <ValidationError
            prefix="Description"
            field="other"
            errors={state.errors}
            className={'text-sm text-red-600'}
          />
          <ValidationError
            errors={state.errors}
            className={'text-sm text-red-600'}
          />
          <div className={'mt-6'}>
            <button
              className="buttonPrimary float-right"
              type="submit"
              disabled={state.submitting}
            >
              {state.submitting ? 'Sending…' : 'Send'}
            </button>
          </div>
        </form>
      )}
    </Modal>
  )
}
